import {
    IDataArray,
} from "../index"

export class SurveyMinesite implements IDataArray {
    public Pkid = 0;
    public SurveyId: number;
    public MinesiteId: number;

    public GetById(): number {
        return this.Pkid;
    }
}